import { render, staticRenderFns } from "./MainValleyInfo.vue?vue&type=template&id=a5fd3f48&scoped=true&"
import script from "./MainValleyInfo.vue?vue&type=script&lang=js&"
export * from "./MainValleyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainValleyInfo.vue?vue&type=style&index=0&id=a5fd3f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fd3f48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
